import React from "react";
import WarningIcon from 'material-ui/svg-icons/alert/warning';

/**
 * @param {{ orderNumber: number, warnings: any, text: string }} param0 
 */
export default function Title({ orderNumber, warnings, text }) {
    return (
        <React.Fragment>
            <div 
                className='title title_sticky' 
                style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '35px',
                    fontWeight: 'bold',
                }}
            >
                {text} {orderNumber}
                {
                    warnings && warnings.length ? <WarningIcon color='orangered' /> : null
                }
            </div>
            {
                warnings && warnings.length ?
                    <div style={{ 
                        display: 'flex', 
                        color: 'orangered', 
                        flexDirection: 'column', 
                        alignItems: 'center', 
                        gap: '5px', 
                        marginTop: '5px' 
                    }}>
                        <span>Warnings</span>
                        <ol>
                            {
                                warnings.map(w => <li>{w.message}</li>)
                            }
                        </ol>
                    </div>
                : null
            }
        </React.Fragment>
    );    
}



// WEBPACK FOOTER //
// ./app/components/common/RequestTitle.jsx